var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRollingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ybaeo9xp8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1600 0v1200H0V0h1600z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e078939cdb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14 6.285c.59.015.883.717.46 1.13L3.495 8.5c.68.58 1.556.928 2.505.928 1.665 0 3.127-1.044 3.637-2.598a.802.802 0 0 1 1.008-.505c.42.11.652.574.492.987-.725 2.206-2.798 3.687-5.16 3.687-1.362 0-2.64-.52-3.613-1.386l-1.212 1.191C.727 11.222 0 10.926 0 10.336V6.754c0-.255.208-.461.467-.469zM6 0c1.385 0 2.662.52 3.635 1.387L10.848.196C11.273-.222 12 .074 12 .664v3.581a.474.474 0 0 1-.467.469H7.86c-.59-.015-.883-.717-.482-1.13L8.505 2.5A3.852 3.852 0 0 0 6 1.571c-1.665 0-3.127 1.044-3.638 2.6a.801.801 0 0 1-1.007.506.782.782 0 0 1-.515-.99C1.565 1.483 3.638 0 6 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ybaeo9xp8a)",
    transform: "translate(-445 -833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e078939cdb)",
    transform: "translate(445 833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v11H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingIcon);
export default __webpack_public_path__ + "static/media/rolling-icon.1fa060114aa9af3d9b90be520993cbf6.svg";
export { ForwardRef as ReactComponent };